<template>
  <Transition
    name="scale-fade-out"
    appear
  >
    <li>
      <AppLink
        :to="{ name: toRoute, params: { slug: event.slug }}"
      >
        <figure>
          <img
            v-if="event?.eventImage"
            loading="lazy"
            :src="event.eventImage"
            :alt="event.name"
          >

          <div v-else>
            <FontAwesomeIcon :icon="faImage" />
            <p>Event Image Unavailable</p>
          </div>
        </figure>

        <div class="event-details">
          <time :datetime="event.date">{{ dateFormatter.formatShortDate(event.date) }}</time>
          <h3>{{ event.name }}</h3>
        </div>

        <p class="link">
          View Photos
          <FontAwesomeIcon :icon="faChevronRight" />
        </p>
      </AppLink>
    </li>
  </Transition>
</template>

<script setup>
import { AppLink } from '@/components/app';

import { useDateFormatter } from '@/composables';
import { ref } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faImage } from '@fortawesome/pro-solid-svg-icons';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';

defineProps({
  event: Object,
});

const dateFormatter = useDateFormatter();

const toRoute = ref('app_event_show');

</script>
